import { defineStore } from 'pinia';
import { RootMetaType, MetaType } from './MetaStore.interface';

export const useMetaStore = defineStore({
	id: 'metaStore',
	state: (): RootMetaType => {
		return {
			meta: {
				title: undefined,
				description: undefined,
				ogTitle: undefined,
				ogDescription: undefined,
				ogImage: undefined,
				theme: '#000',
			},
		};
	},
	getters: {
		getMeta: (state) => {
			return state.meta;
		},
	},
	actions: {
		setMeta(meta: MetaType) {
			this.meta = meta;
		},
	},
});
